import loadGoogleMapsApi from 'load-google-maps-api';
import { mapStyle, mapOptions } from './constants';

export default class Maps {
  constructor() {
    this.mapContainer = document.getElementById('map_canvas');
    if (this.mapContainer) {
      loadGoogleMapsApi({
        key: 'AIzaSyBhPrvov-iBXN9QOt9bRMo0pwBWsMlAahQ',
      }).then((google) => {
        this.google = google;
        this.init(google);
      });
    }
  }

  init = (google) => {
    //this.myLatlng = new google.LatLng(25.187738, 55.258221);
    this.mapCenter = new google.LatLng(25.213922, 55.280481);
    this.mapIconUrl = `${CCM_REL}/themes/courts/dist/images/marker.png`;
    this.map = new google.Map(this.mapContainer, {
      ...mapOptions(google),
      ...{
        center: this.mapCenter,
        styles: mapStyle,
      },
    });
    this.marker = new google.Marker({
      position: this.myLatlng,
      map: this.map,
      animation: google.Animation.DROP,
      icon: this.mapIconUrl,
      title: 'Maps',
    });
    this.bindEvents();

    let locations = [];
    let marker = [];
    let pos = [];
    let setcondt = 0;
    if($('body').hasClass('contact-page')){
      $('.contact_div .address_sec .each_location').each(function(i,obj){
        const title = $(this).find('.loc_name').text().trim();
        const lat = $(this).find('.lat_long').text().split(',')[0];
        const long = $(this).find('.lat_long').text().split(',')[1];
        const img_url = $(this).find('.img_url img').attr('src');
        const loc = {
          loc_id    : lat,
          title     : title,
          class     : 'icon',
          img_url   : img_url,
          lat       : lat.trim(),
          long      : long.trim(),
        }
        locations.push(loc)
      })
    }else if($('.wrapper').hasClass('page-type-will-registration')){
      $('.will_address .each_location').each(function(i,obj){
        const title = $(this).find('.loc_name').text().trim();
        const lat = $(this).find('.lat_long').text().split(',')[0];
        const long = $(this).find('.lat_long').text().split(',')[1];
        const img_url = $(this).find('.img_url img').attr('src');
        const loc = {
          loc_id    : lat,
          title     : title,
          class     : 'icon',
          img_url   : img_url,
          lat       : lat.trim(),
          long      : long.trim(),
        }
        locations.push(loc)
      })
    }else if($('.wrapper').hasClass('page-template-arbitration-suite')){
      $('.as_loc .each_location').each(function(i,obj){
        const title = $(this).find('.loc_name').text().trim();
        const lat = $(this).find('.lat_long').text().split(',')[0];
        const long = $(this).find('.lat_long').text().split(',')[1];
        const img_url = $(this).find('.img_url img').attr('src');
        const loc = {
          loc_id    : lat,
          title     : title,
          class     : 'icon',
          img_url   : img_url,
          lat       : lat.trim(),
          long      : long.trim(),
        }
        locations.push(loc)
      })
    }

    

    

    locations.map(item => {
      setcondt = 1;
      this[`${item.loc_id}-marker`] = new google.Marker({
          position  : new google.LatLng(item.lat, item.long),
          map       : this.map,
          icon      : item.img_url,
          title     : item.title
      });
      pos.push(this[`${item.loc_id}-marker`])
      this.map.setCenter(new google.LatLng(item.lat, item.long));
      const content = item.title;
      if(content){
        this.infowindow   = new google.InfoWindow({
          content     : content,
          pixelOffset : new google.Size(60,0)
        });
        this.infowindow.open(this.map, this[`${item.loc_id}-marker`]);
      }
    });
  };





  bindEvents = () => {
    this.google.event.addListener(this.marker, 'click', this.toggleBounce);
  };

  toggleBounce = (markerClicked) => {
    if (markerClicked.getAnimation() != null) {
      markerClicked.setAnimation(null);
    } else {
      markerClicked.setAnimation(this.google.Animation.BOUNCE);
    }
  };
}
